<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" data-title="회원가입" :type="'empty'"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <div class="progress">
          <ol>
            <li class="on"><span>약관동의</span></li>
            <li><span>정보입력</span></li>
            <li><span>정보입력(선택)</span></li>
          </ol>
        </div>

        <section class="hr">
          <div class="titArea">
            <h2 class="titH3 normal">약관동의</h2>
            <p class="giftTime">
              <span class="blind">타임미션 제한시간</span>
              <span class="timer" :class="{ pointC1: time > 300 }">{{ time | convertTimeToMS }}</span>
            </p>
          </div>

          <!-- 약관 (s) -->
          <div class="termsWrap">
            <div class="block accoHead">
              <input type="checkbox" class="ipt" name="terms1" id="allTerm" v-model="chkAll" />
              <label for="allTerm">전체동의</label>
            </div>

            <p class="txtXS pointC6 mb10">
              고객 편의 제공을 위하여 여러 동의사항에 대한 '전체 동의' 기능을 제공하고 있습니다.
            </p>

            <div class="accoBody">
              <ul class="iptGroup">
                <li>
                  <div class="block">
                    <input type="checkbox" class="ipt" name="termsSub" id="term1" value="0" v-model="chkSub" />
                    <label for="term1">
                      웰몰 서비스 이용을 위한
                      <em>필수</em>
                      동의
                    </label>
                    <button type="button" class="links arrow" onClick="document.getElementById('term1').click()">
                      <span class="blind">상세약관 전체보기</span>
                    </button>
                  </div>
                </li>
                <li>
                  <div class="block">
                    <input type="checkbox" class="ipt" name="termsSub" id="term2" value="1" v-model="chkSub" />
                    <label for="term2">
                      서비스 제공을 위한 개인정보 수집/이용
                      <em>필수</em>
                      동의
                    </label>
                    <button type="button" class="links arrow" onClick="document.getElementById('term2').click()">
                      <span class="blind">상세약관 전체보기</span>
                    </button>
                  </div>
                </li>
                <!--<li class="accoItem">
                  <div class="block accoHead">
                    <input type="checkbox" class="ipt notDel uiAct chkSubAll" v-model="chkSub2All" name="terms2All" id="terms2" value="terms2All" />
                    <label for="terms2">
                      휴대폰 본인인증 서비스
                      <em>필수</em>
                      동의
                    </label>
                    <button type="button" class="btnIco_acco accoBtn" role="button" tabindex="0" aria-expanded="false" aria-controls="acco_1">
                      <span>
                        <span class="blind">상세약관</span>
                        전체보기
                      </span>
                    </button>
                  </div>
                  <div class="accoBody">
                    <ul class="iptGroup">
                      <li>
                        <div class="block">
                          <input type="checkbox" class="ipt notDel uiAct chkSub" name="termsSub2" id="terms2_1" value="3" v-model="chkSub" />
                          <label for="terms2_1">
                            <span>[필수]</span>
                            개인정보 수집/이용동의
                          </label>
                          <button type="button" class="links arrow" onClick="document.getElementById('terms2_1').click()">
                            <span class="blind">상세약관 전체보기</span>
                          </button>
                        </div>
                      </li>
                      <li>
                        <div class="block">
                          <input type="checkbox" class="ipt notDel uiAct chkSub" name="termsSub2" id="terms2_2" value="4" v-model="chkSub" />
                          <label for="terms2_2">
                            <span>[필수]</span>
                            고유식별정보처리 동의
                          </label>
                          <button type="button" class="links arrow" onClick="document.getElementById('terms2_2').click()">
                            <span class="blind">상세약관 전체보기</span>
                          </button>
                        </div>
                      </li>
                      <li>
                        <div class="block">
                          <input type="checkbox" class="ipt notDel uiAct chkSub" name="termsSub2" id="terms2_3" value="5" v-model="chkSub" />
                          <label for="terms2_3">
                            <span>[필수]</span>
                            휴대폰본인확인 이용약관동의
                          </label>
                          <button type="button" class="links arrow" onClick="document.getElementById('terms2_3').click()">
                            <span class="blind">상세약관 전체보기</span>
                          </button>
                        </div>
                      </li>
                      <li>
                        <div class="block">
                          <input type="checkbox" class="ipt notDel uiAct chkSub" name="termsSub2" id="terms2_4" value="6" v-model="chkSub" />
                          <label for="terms2_4">
                            <span>[필수]</span>
                            통신사이용약관동의
                          </label>
                          <button type="button" class="links arrow" onClick="document.getElementById('terms2_4').click()">
                            <span class="blind">상세약관 전체보기</span>
                          </button>
                        </div>
                      </li>
                    </ul>
                  </div>
                </li>-->
                <li>
                  <div class="block accoHead">
                    <input type="checkbox" class="ipt" name="termsSub" id="terms3" v-model="chkSub3All" value="2" />
                    <label for="terms3">
                      상품서비스 안내 등을 위한
                      <em>선택</em>
                      동의
                    </label>
                    <button type="button" class="btnIco_acco accoBtn">
                      <span>
                        <span class="blind">상세약관</span>
                        전체보기
                      </span>
                    </button>
                  </div>
                  <div class="accoBody">
                    <ul class="iptGroup">
                      <li>
                        <div class="block">
                          <input type="checkbox" class="ipt" name="termsGroup1" id="terms3_1" v-model="agreeCollection" />
                          <label for="terms3_1">
                            <span>[선택]</span>
                            개인(신용)정보 수집 및 이용 동의
                          </label>
                          <button type="button" class="links arrow" onClick="document.getElementById('terms3_1').click()">
                            <span class="blind">상세약관 전체보기</span>
                          </button>

                          <ul class="iptGroup div_3">
                            <li>
                              <input type="checkbox" class="ipt" name="chk0" id="chk0_1" v-model="agreeTel" />
                              <label for="chk0_1">전화</label>
                            </li>
                            <li>
                              <input type="checkbox" class="ipt" name="chk0" id="chk0_2" v-model="agreeSms" />
                              <label for="chk0_2">문자메세지</label>
                            </li>
                            <li>
                              <input type="checkbox" class="ipt" name="chk0" id="chk0_3" v-model="agreeDm" />
                              <label for="chk0_3">DM</label>
                            </li>
                            <li>
                              <input type="checkbox" class="ipt" name="chk0" id="chk0_4" v-model="agreeEmail" />
                              <label for="chk0_4">이메일</label>
                            </li>
                            <li>
                              <input type="checkbox" class="ipt" name="chk0" id="chk0_5" v-model="agreeAppPush" />
                              <label for="chk0_5">푸시</label>
                            </li>
                          </ul>
                        </div>
                      </li>
                      <!--<li>
                        <div class="block">
                          <input type="checkbox" class="ipt" name="termsGroup1" id="terms3_2" v-model="agreeCredit" />
                          <label for="terms3_2">
                            <span>[선택]</span>
                            개인(신용)정보 제공 동의
                          </label>
                          <button type="button" class="links arrow" onClick="document.getElementById('terms3_2').click()">
                            <span class="blind">상세약관 전체보기</span>
                          </button>
                        </div>
                      </li>-->
                    </ul>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- 약관 (e) -->
          <p class="txtList_star">
            14세 이상 서비스 이용가능합니다.(14세 미만은 회원가입 제한)
          </p>
          <div class="btnArea sticky">
            <button type="button" class="btn_p" @click="join" :disabled="regButtonShow">다음</button>
          </div>
        </section>
      </div>
      <!-- content(e) -->
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>

    <MessagePop v-if="messagePop" @close="messagePop = false">
      <p v-html="msg"></p>
    </MessagePop>

    <ConfirmPop v-if="confirmPop" @cancel="cancel" @confirm="confirm" @close="confirmPop = false">
      <p v-html="msg"></p>
      <template v-slot:btnArea>동의안함</template>
      <template v-slot:btnArea2>동의함</template>
    </ConfirmPop>

    <WebViewPop v-if="webViewPop" :pageName="pageName" @close="webviewClose" :type="webViewType">
      <div v-html="webView"></div>
      <template v-slot:closeButton>
        <button type="button" class="btnIco_close" @click="disagreement">
          <span>팝업 닫기</span>
        </button>
      </template>
    </WebViewPop>
  </div>
  <!-- wrapper(e) -->
</template>
<script>
import ApiService from '@/common/api.service';
import MessagePop from '@/components/popup/MessagePop';
import ConfirmPop from '@/components/popup/ConfirmPop';
import WebViewPop from '@/components/popup/WebViewPop';
import { TERM_AGREE_JOIN, TERM_AGREE_JOIN_C } from '@/store/message.type.js';
import { SET_JOIN_INFO } from '@/store/mutations.type';

export default {
  name: 'JoinStep2',
  components: { MessagePop, ConfirmPop, WebViewPop },
  async mounted() {
    // 회원가입 필수, 선택동의 웹뷰 url 리스트
    let webViews = await ApiService.service('GET', 'common/webView/WB000006');
    this.webViews = webViews.data.result;
    for (let url of this.webViews) {
      let res = await ApiService.service('GET', url.filePath);
      this.allUrl.push(res);
    }
    // 시간미션 이벤트
    this.time = window.localStorage.getItem('time');
    this.timeEvent = setInterval(() => {
      this.time++;
    }, 1000);
    /*this.timeEvent = setInterval(() => {
        if (this.countUp) this.time++;
        else this.time--;
      }, 1000);*/
  },
  data() {
    return {
      chkSubNum: '-1',
      time: null, // 회원가입 이벤트용 시간
      chkSubCnt: 0,

      chkAll: false, // 전체동의
      chkSub: [], // 필수, 선택 동의 여부

      msg: null, // 팝업 메세지
      messagePop: false, // 메세지 팝업
      confirmPop: false, // 확인 팝업
      webViewPop: false, // 웹뷰 팝업
      webView: null, // 웹뷰 URL
      webViews: [], // 웹뷰 리스트
      webViewType: 'agree',
      pageName: null, // 웹뷰 타이틀
      allUrl: [],

      agrAct0: true, // 전체동의
      agrAct1: true, // 1번 약관동의 액션 세이프키
      agrAct2: true, // 2번 약관동의 액션 휴대폰
      agrAct3: true, // 3번 약관동의 액션 상품서비스
      //chkSub2All: false,
      chkSub3All: false,
      chkSub4All: false,
      agreeAppPush: false,
      agreeCollection: false,
      agreeDm: false,
      agreeEmail: false,
      agreeSms: false,
      agreeTel: false,
      //agreeCredit: false,

      regButtonShow: true,
    };
  },
  watch: {
    // 시간미션 이벤트
    /*time() {
        if (this.time == 0) {
          this.time = 300;
          this.countUp = true;
        }
        if (this.time > 300) {
          this.countUp = true;
        }
      },*/
    chkSub() {
      //console.log(this.chkSub);
      if (this.chkSub.length - this.chkSubCnt == 1) {
        this.openPop(this.chkSub[this.chkSub.length - 1]);
        const chk1 = this.chkSub.includes('0');
        const chk2 = this.chkSub.includes('1');
        if (!this.chkAll && chk1 && chk2 && this.chkSub3All) {
          console.log('chksub1');
          this.agrAct0 = false;
          this.chkAll = true;
        }
      } else if (this.chkSub.length - this.chkSubCnt == -1) {
        const chk1 = this.chkSub.includes('0');
        const chk2 = this.chkSub.includes('1');
        /*
          const chk4 = this.chkSub.includes('3');
          const chk5 = this.chkSub.includes('4');
          const chk6 = this.chkSub.includes('5');
          const chk7 = this.chkSub.includes('6');
          if (this.chkSub2All) {
            if (!chk4 || !chk5 || !chk6 || !chk7) {
              this.agrAct2 = false;
              this.chkSub2All = false;
              if (this.chkAll) {
                this.agrAct0 = false;
                this.chkAll = false;
              }
            }
          }*/
        if (this.chkAll && (!chk1 || !chk2)) {
          console.log('chksub2');
          this.agrAct0 = false;
          this.chkAll = false;
        }
      }
      this.chkSubCnt = this.chkSub.length;

      this.checkInput();
    },
    chkAll() {
      //전체 선택은 체크 하되 하위액션은 X
      console.log(this.chkAll + ':chkAll:' + this.agrAct0);
      if (this.agrAct0 == false) {
        this.agrAct0 = true;
        return false;
      }
      //약관 초기화
      this.chkSub = [];

      this.agrAct2 = true;
      this.agrAct3 = true;
      this.agreeAppPush = false;
      this.agreeCollection = false;
      this.agreeDm = false;
      this.agreeEmail = false;
      this.agreeSms = false;
      this.agreeTel = false;
      //this.agreeCredit = false;
      if (this.chkAll) {
        console.log('open');
        this.openPop(-1);

        //this.chkSub2All = true;
        this.chkSub3All = true;

        const array_termsSub = document.getElementsByName('termsSub');
        for (let i = 0; i < array_termsSub.length; i++) {
          console.log(array_termsSub[i].value);
          this.chkSub.push(array_termsSub[i].value);
          console.log(this.chkSub);
        }
        /*

          const array_termsSub2 = document.getElementsByName('termsSub2');

          for (let i = 0; i < array_termsSub2.length; i++) {
            console.log(array_termsSub2[i].value);
            this.chkSub.push(array_termsSub2[i].value);
          }
*/

        this.agreeAppPush = true;
        this.agreeCollection = true;
        this.agreeDm = true;
        this.agreeEmail = true;
        this.agreeSms = true;
        this.agreeTel = true;
        //this.agreeCredit = true;
      } else {
        this.chkSub = [];
        this.agrAct2 = false;
        this.agrAct3 = false;
        //this.chkSub2All = false;
        this.agreeAppPush = false;
        this.agreeCollection = false;
        this.agreeDm = false;
        this.agreeEmail = false;
        this.agreeSms = false;
        this.agreeTel = false;
        //this.agreeCredit = false;
      }
    },
    /*chkSub2All() {
        const chk1 = this.chkSub.includes('0');
        const chk2 = this.chkSub.includes('1');

        if (this.chkSub2All) {
          if (!this.chkAll && chk1 && chk2 && this.chkSub2All && this.chkSub3All) {
            //전체 체크 안되고  // 1번 2번 체크 //휴대폰 전체 체크 // 선택 체크시 <<전체동의 변경
            console.log('chksub2all1');
            this.agrAct0 = false;
            this.chkAll = true;
          }
        } else {
          /!*console.log("all :"+this.chkAll);
          console.log("1 :"+chk1 +",2 :"+chk2);
          console.log("3 :"+this.chkSub3All);*!/
          if (chk1 && chk2 && this.chkSub3All && this.chkAll) {
            console.log('chksub2all2');
            this.agrAct0 = false;
          }
          this.chkAll = false;
        }

        if (this.agrAct2 == false) {
          this.agrAct2 = true;
          return false;
        }

        if (this.chkSub2All) {
          const array_termsSub = document.getElementsByName('termsSub2');
          for (let i = 0; i < array_termsSub.length; i++) {
            this.chkSub = this.chkSub.filter(item => item !== array_termsSub[i].value);
          }

          const array_termsSub_bak = document.getElementsByName('termsSub2');

          for (let i = 0; i < array_termsSub_bak.length; i++) {
            this.chkSub.push(array_termsSub_bak[i].value);
          }

          this.openPop(-3);
        } else {
          const array_termsSub = document.getElementsByName('termsSub2');
          for (let i = 0; i < array_termsSub.length; i++) {
            this.chkSub = this.chkSub.filter(item => item !== array_termsSub[i].value);
          }
        }
      },*/
    chkSub3All() {
      const chk1 = this.chkSub.includes('0');
      const chk2 = this.chkSub.includes('1');

      if (this.chkSub3All) {
        if (!this.chkAll && chk1 && chk2 && this.chkSub3All) {
          //전체 체크 안되고  // 1번 2번 체크 //휴대폰 전체 체크 // 선택 체크시 <<전체동의 변경
          console.log('chksub3all1');
          this.agrAct0 = false;
          this.chkAll = true;
        }
      } else {
        if (chk1 && chk2 && this.chkAll) {
          console.log('chksub3all2');
          this.agrAct0 = false;
        }
        this.chkAll = false;
      }

      if (this.agrAct3 == false) {
        this.agrAct3 = true;
        return false;
      }

      if (this.chkSub3All && this.agreeCollection) {
      } else if (this.chkSub3All) {
        this.openPop(-4);

        this.agreeAppPush = true;
        this.agreeCollection = true;
        this.agreeDm = true;
        this.agreeEmail = true;
        this.agreeSms = true;
        this.agreeTel = true;
      } else {
        this.agreeAppPush = false;
        this.agreeCollection = false;
        this.agreeDm = false;
        this.agreeEmail = false;
        this.agreeSms = false;
        this.agreeTel = false;
      }
    },
    agreeCollection() {
      console.log(this.agreeCollection && (this.agreeAppPush || this.agreeDm || this.agreeEmail || this.agreeSms || this.agreeTel));

      if (this.agreeCollection && (this.agreeAppPush || this.agreeDm || this.agreeEmail || this.agreeSms || this.agreeTel)) {
        if (!this.chkSub3All) {
          this.agrAct3 = false;
          this.chkSub3All = true;
        }
      } else if (this.agreeCollection) {
        this.openPop(6);
        this.agreeAppPush = true;
        this.agreeCollection = true;
        this.agreeDm = true;
        this.agreeEmail = true;
        this.agreeSms = true;
        this.agreeTel = true;
      } else {
        this.agreeAppPush = false;
        this.agreeCollection = false;
        this.agreeDm = false;
        this.agreeEmail = false;
        this.agreeSms = false;
        this.agreeTel = false;

        if (this.chkSub3All) {
          this.agrAct3 = false;
          this.chkSub3All = false;
        }
      }
    },
    /* agreeCredit() {
        if (!this.agreeCredit && this.chkSub3All) {
          this.agrAct3 = false;
          this.chkSub3All = false;
        }
        if (this.agreeCredit && !this.chkAll && !this.chkSub3All) {
          this.openPop(7);
        }
      },*/
    agreeAppPush() {
      if (this.agreeAppPush) {
        this.agreeCollection = true;
      } else {
        if (!(this.agreeAppPush || this.agreeDm || this.agreeEmail || this.agreeSms || this.agreeTel)) {
          this.agreeCollection = false;
        }
      }
    },
    agreeDm() {
      if (this.agreeDm) {
        this.agreeCollection = true;
      } else {
        if (!(this.agreeAppPush || this.agreeDm || this.agreeEmail || this.agreeSms || this.agreeTel)) {
          this.agreeCollection = false;
        }
      }
    },
    agreeEmail() {
      if (this.agreeEmail) {
        this.agreeCollection = true;
      } else {
        if (!(this.agreeAppPush || this.agreeDm || this.agreeEmail || this.agreeSms || this.agreeTel)) {
          this.agreeCollection = false;
        }
      }
    },
    agreeSms() {
      if (this.agreeSms) {
        this.agreeCollection = true;
      } else {
        if (!(this.agreeAppPush || this.agreeDm || this.agreeEmail || this.agreeSms || this.agreeTel)) {
          this.agreeCollection = false;
        }
      }
    },
    agreeTel() {
      if (this.agreeTel) {
        this.agreeCollection = true;
      } else {
        if (!(this.agreeAppPush || this.agreeDm || this.agreeEmail || this.agreeSms || this.agreeTel)) {
          this.agreeCollection = false;
        }
      }
    },
  },
  methods: {
    // 회원가입 다음단계
    join: function() {
      // 필수약관 동의 시
      if (this.chkSub.includes('0') && this.chkSub.includes('1')) {
        // 선택약관 미동의 시
        if (!this.agreeCollection) {
          this.msg = TERM_AGREE_JOIN_C;
          this.confirmPop = true;
        } else {
          // 전부 동의시
          let agree = {
            //선택 동의
            agreeAppPush: this.agreeAppPush,
            agreeCollection: this.agreeCollection,
            agreeCredit: false,
            agreeDm: this.agreeDm,
            agreeEmail: this.agreeEmail,
            agreeSms: this.agreeSms,
            agreeTel: this.agreeTel,
          };

          window.localStorage.setItem('selectAgreeInfo', JSON.stringify(agree));
          this.$router.push({ name: 'joinStep3' });
        }
      } else {
        this.msg = TERM_AGREE_JOIN;
        this.messagePop = true;
      }
    },
    // 웹뷰 팝업 호출
    getWebview(num) {
      this.chkSubNum = num;
      // this.webViewUrl = 'http://localhost:3000/test1.html'; // 테스트
      this.webViewUrl = this.webViews[num].filePath;
      this.pageName = this.webViews[num].pageName;

      ApiService.service('GET', this.webViewUrl)
        .then(({ data }) => {
          //console.log(data);
          this.webView = data;
          this.webViewPop = true;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    async openPop(num) {
      //this.pageName = pageName;
      if (this.webViewPop) return false;
      this.webViewPop = true;

      console.log(num);
      this.chkSubNum = num;
      if (num < 0) {
        if (num == -1) {
          this.pageName = '전체 약관';
        } else if (num == -3) {
          this.pageName = '휴대폰 본인인증 서비스 약관';
        } else if (num == -4) {
          this.pageName = '상품서비스 안내등을 위한 약관';
        }
        let html = '';

        for (let i = 0; i < this.allUrl.length; i++) {
          if (num == -3 && (i < 2 || i > 5)) {
            continue;
          }
          if (num == -4 && i < 6) {
            continue;
          }

          let res = this.allUrl[i];
          html += res.data;
        }

        this.webView = html;
      } else {
        this.webViewUrl = this.webViews[num].filePath;
        this.pageName = this.webViews[num].pageName;
        let res = this.allUrl[num];
        this.webView = res.data;
        this.webViewPop = true;
      }
    },
    // 선택동의 안하고 회원가입 다음단계 진행시 분기 처리
    cancel() {
      // 선택동의 안함
      let agree = {
        //선택 동의
        agreeAppPush: false,
        agreeCollection: false,
        //agreeCredit: false,
        agreeDm: false,
        agreeEmail: false,
        agreeSms: false,
        agreeTel: false,
      };
      window.localStorage.setItem('selectAgreeInfo', JSON.stringify(agree));
      this.$router.push('joinStep3');
    },
    confirm() {
      // 선택동의 함
      let agree = {
        agreeAppPush: true,
        agreeCollection: true,
        //agreeCredit: true,
        agreeDm: true,
        agreeEmail: true,
        agreeSms: true,
        agreeTel: true,
      };
      window.localStorage.setItem('selectAgreeInfo', JSON.stringify(agree));
      this.$router.push('joinStep3');
    },
    /*putAgree: function(){
        console.log(this.chkSubNum);
        let num = this.chkSubNum.toString();
        if(this.chkSubNum>-1) {

          for(let i = 0; i< this.chkSub.length; i++){
            if(num == this.chkSub[i]){
              this.chkSub.slice(i, 1);
            }
          }
          this.chkSub.push(num);

        }

        this.webViewPop=false;
      },*/
    webviewClose() {
      console.log(this.chkSubNum);
      if (this.chkSubNum > -1) {
        if (!this.chkSub3All && this.agreeCollection) {
          this.agrAct3 = false;
          this.chkSub3All = true;
        }
      }
      this.webViewPop = false;
    },

    disagreement() {
      let num = this.chkSubNum.toString();
      console.log(num);
      if (num == -1) {
        this.agrAct0 = true;
        this.chkAll = false;
      } else if (num == -3) {
        this.chkSub2All = false;
      } else if (num == -4) {
        this.chkSub3All = false;
      } else if (num == '6') {
        this.agreeCollection = false;
      } else if (num == '7') {
        this.agreeCredit = false;
      } else {
        for (let i = 0; i < this.chkSub.length; i++) {
          if (num == this.chkSub[i].toString()) {
            this.chkSub.splice(i, 1);
          }
        }
      }

      console.log(this.chkSub);
      this.webViewPop = false;
    },
    checkInput() {
      if (this.chkSubCnt > 1) {
        this.regButtonShow = false;
      } else {
        this.regButtonShow = true;
      }
    },
  },
  beforeDestroy() {
    // 페이지 이탈시 시간미션 시간 저장, 회원가입정보 저장된게 있으면 null 처리
    window.localStorage.setItem('time', this.time);
    this.$store.commit(SET_JOIN_INFO, null);
  },
};
</script>
